import bem from 'utils/bem';

export const logoModalBlock = bem('logo-modal');
